import { useState } from 'react';
import { useTheme, spacing } from '@fti/design-system';

interface HelpTextProps {
  children: React.ReactNode;
  collapsible?: {
    label: string;
    content: React.ReactNode;
  };
}

export function HelpText({ children, collapsible }: HelpTextProps) {
  const { theme } = useTheme();
  const [expanded, setExpanded] = useState(false);

  return (
    <div style={{ marginBottom: spacing.xs }}>
      <p style={{ fontSize: '0.8rem', color: theme.colors.text.secondary, margin: 0, lineHeight: 1.5 }}>
        {children}
      </p>
      {collapsible && (
        <div style={{ marginTop: spacing.xs }}>
          <button
            onClick={() => setExpanded(!expanded)}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              fontSize: '0.75rem',
              color: theme.colors.primary[500],
              fontWeight: 500,
            }}
          >
            {expanded ? 'Hide example' : collapsible.label}
          </button>
          {expanded && (
            <div
              style={{
                marginTop: spacing.xs,
                padding: spacing.sm,
                backgroundColor: theme.colors.background.paper,
                border: `1px solid ${theme.colors.border.default}`,
                borderRadius: '4px',
                fontSize: '0.75rem',
                color: theme.colors.text.secondary,
                lineHeight: 1.6,
                whiteSpace: 'pre-wrap',
              }}
            >
              {collapsible.content}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
